import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const WorldLostRo = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Lumea Care Aproape S-a Pierdut" subtitle="Actul I" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            Povestea nu începe cu triumf, ci cu judecată. Pământul de la mijlocul secolului XXI este o lume în cădere liberă — recife de corali prăbușindu-se, Amazonia transformată în savană, <span className="text-white font-medium">2 miliarde de refugiați climatici</span> în mișcare și o civilizație incapabilă să-și aleagă propria supraviețuire în detrimentul confortului propriu.
          </p>
          <p className="text-gray-400 leading-relaxed">
            Când pandemia <span className="text-brand-accent font-medium">Marburg-X</span> mătură globul între 2067 și 2070, ucigând 340 de milioane în trei ani, nu zdrobește umanitatea — o forțează în sfârșit să pună întrebarea pe care o evitase: <em className="text-white">ce suntem dispuși să devenim?</em>
          </p>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
          className="bg-brand-surface border border-white/5 rounded-2xl p-8">
          <div className="space-y-6">
            {[
              { label: "Refugiați climatici strămutați", value: "2 Miliarde" },
              { label: "Victime Marburg-X", value: "340 Milioane" },
              { label: "Populația maximă a Pământului (2058)", value: "7,4 Miliarde" },
              { label: "Populația Pământului în 2501", value: "3 Miliarde" },
            ].map((stat, i) => (
              <div key={i} className="flex justify-between items-center border-b border-white/5 pb-4 last:border-0 last:pb-0">
                <span className="text-gray-500 text-sm">{stat.label}</span>
                <span className="text-brand-accent font-display font-bold text-xl">{stat.value}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="mt-10 bg-brand-surface border-l-4 border-brand-accent rounded-r-xl p-6">
        <p className="text-gray-300 leading-relaxed">
          Răspunsul vine dintr-un laborator din Zürich, unde <span className="text-white font-semibold">Dr. Elena Vasquez</span> produce primul procesor cuantic stabil — o mașinărie capabilă să facă ceva ce nicio mașinărie nu a putut face vreodată. Acel moment este scânteia Trezirii Cuantice, punctul de inflexiune civilizațional în jurul căruia gravitează toate cele unsprezece capitole.
        </p>
      </motion.div>
    </div>
  </section>
);

export default WorldLostRo;